import { defineStore, getActivePinia } from "pinia";
import { ToastFailed, ToastSuccess } from "@/helper/services/toast";
import router from "../router";
import http from "../helper/services/http";

import { useUIStore } from "./ui";
import useDocumentStore from "@/stores/document";
import axios from "axios";
import useMiddleware from "@/helper/hooks/useMiddleware";

export default defineStore("auth", {
  state() {
    return {
      isLoggedIn: false,
      user: JSON.parse(localStorage.getItem("user")) || {},
      token: "",
      tempToken: "",
      file: {
        signature: localStorage.getItem("signature"),
        initial: localStorage.getItem("initial"),
        bsreSignature: {
          long: localStorage.getItem("bsreSignatureLong"),
          short: localStorage.getItem("bsreSignatureShort"),
          wrapLong: localStorage.getItem("bsreSignatureWrapLong"),
          wrapShort: localStorage.getItem("bsreSignatureWrapShort"),
        },
        initialFileName: undefined,
        signatureFileName: undefined,
      },
      summary: null,
      filesInfo: null,
      allFilesInfo: null,
      allUsersInfo: null,
      storageInfo: null,
      lastFetchTime: {},
      userBSREInfo: null,
      roles: {},
      emailForOtp: null,
    };
  },
  getters: {
    isDataExpired: (state) => (key) => {
      if (!state.lastFetchTime[key]) {
        return true;
      }
      const expirationTime = new Date(
        state.lastFetchTime[key].getTime() + 60 * 60 * 1000
      );
      return expirationTime < new Date();
    },
  },
  actions: {
    sendOTPForgotPassword(email) {
      useUIStore().setLoading(true);
      http({ path: "auth", requiresAuth: false })
        .post("users/send-otp", { email })
        .then((res) => {
          sessionStorage.setItem("email", email);
          if (res.data.code > 0) {
            ToastFailed.fire({
              icon: "error",
              title: res.data.message,
            });
            return;
          }
          ToastSuccess.fire({
            icon: "success",
            title: "Kode OTP sudah berhasil dikirimkan",
          });
          router.push({
            name: "verifyOTP",
            query: { flow: "forgot-password" },
          });
        })
        .catch((err) => {
          ToastFailed.fire({
            icon: "error",
            title: err.response.data.message || err.message,
          });
        })
        .finally(() => useUIStore().setLoading(false));
    },
    verifyOTPForgotPassword(code) {
      useUIStore().setLoading(true);
      http({ path: "auth", requiresAuth: false })
        .post("users/verify-otp", {
          code,
          email: sessionStorage.getItem("email"),
        })
        .then((res) => {
          if (res.data.code > 0) {
            ToastFailed.fire({
              icon: "error",
              title: res.data.message,
            });
            return;
          }
          // ToastSuccess.fire({
          //   icon: "success",
          //   title: "Re-set password berhasil, silahkan masuk kembali.",
          // });
          router.push({ name: "changePassword" });
        })
        .catch(() => {
          ToastFailed.fire({
            icon: "error",
            title: "OTP tidak valid.",
          });
        })
        .finally(() => useUIStore().setLoading(false));
    },

    async login(credential, query = null) {
      useUIStore().setLoading(true);
      try {
        const res = await http({ path: "auth" }).post("login", {
          ...credential,
        });

        if (res.data.message && res.data.code > 0) {
          ToastFailed.fire({
            icon: "error",
            title: res.data.message,
          });
        } else {
          this.emailForOtp = credential.email;
          this.user = res.data.user;
          this.user.email = credential.email;
          localStorage.setItem("user", JSON.stringify(this.user));
          http({ path: "auth" }).post("users/send-otp", {
            email: credential.email,
          });

          if (res.data.user.isChanged == 0) {
            router.push({ name: "changePassword" });
            return;
          }

          if (query) {
            router.push({
              name: "verifyOTP",
              query: { redirect: query, flow: "login" },
            });
          } else {
            router.push({ name: "verifyOTP", query: { flow: "login" } });
          }
        }
      } catch (err) {
        ToastFailed.fire({
          icon: "error",
          title:
            err?.response?.status == 401
              ? "Kesalahan username atau password"
              : "Terjadi kesalahan, silahkan coba lagi",
        });
      } finally {
        useUIStore().setLoading(false);
      }
    },
    async verifyOTPLogin(otp, query = null) {
      useUIStore().setLoading(true);
      try {
        const res = await http({ path: "auth" }).post("users/verify-otp", {
          email: this.emailForOtp,
          code: otp,
        });

        if (res.data.code == 0) {
          this.token = res.data.token;
          this.user = {
            ...res.data.data.user,
            roles: res.data.data.roles,
            expired: new Date(new Date().getTime() + 8 * 60 * 60 * 1000),
          };

          localStorage.setItem("user", JSON.stringify(this.user));
          localStorage.setItem("key", this.token);

          this.isLoggedIn = true;
          this.emailForOtp = null;

          if (query) {
            router.push(query);
          } else {
            router.push({ name: "home" });
          }
        } else {
          ToastFailed.fire({
            icon: "error",
            title: res.data.message,
          });
        }
      } catch (err) {
        ToastFailed.fire({
          icon: "error",
          title: err.response?.data?.message || "Verifikasi OTP gagal",
        });
      } finally {
        useUIStore().setLoading(false);
      }
    },
    async logout() {
      await new Promise((resolve) => resolve(localStorage.clear()));
      const activeStores = Object.keys(getActivePinia().state.value);
      activeStores.forEach((store) => {
        getActivePinia()._s.get(store).$reset();
      });
      if (router.currentRoute.value.name == "changePassword") {
        router.push({ name: "login" });
      } else {
        router.go();
      }
    },
    async changePassword({ newpassword, oldpassword } = {}) {
      useUIStore().setLoading(true);
      let data = { user_id: this.user.id, newpassword };
      let path = "auth";
      let endpoint = "users/reset-password";

      path = "auth";
      if (oldpassword) {
        data = {
          user_id: this.user.id,
          newpassword: newpassword,
          oldpassword: oldpassword,
        };
        endpoint = "users/change-password";
      } else {
        data = {
          email: sessionStorage.getItem("email") || this.user.email,
          password: newpassword,
        };
      }

      return http({ path })
        .post(endpoint, data)
        .then((res) => {
          if (res.data.code > 0) {
            ToastFailed.fire({
              icon: "error",
              title: "Password lama tidak sesuai!",
            });
            return false;
          }
          ToastSuccess.fire({
            icon: "success",
            title: "Berhasil mengubah password",
          });
          return true;
        })
        .catch((err) => {
          ToastFailed.fire({
            icon: "error",
            title: err.response.data.message,
          });
          return false;
        })
        .finally(() => useUIStore().setLoading(false));
    },
    async getSignature(forced = false) {
      const { isUser } = await useMiddleware();
      if ((this.file.signature && !forced) || !isUser.value) return;
      useUIStore().setLoading(true);
      http({ path: "auth" })
        .get(`user-signature/${this.user.id}`, {
          responseType: "blob",
          validateStatus: function (status) {
            return status < 501;
          },
        })
        .then(async (res) => {
          if (res.status != 404) {
            this.file.signature = URL.createObjectURL(res.data);
            const reader = new FileReader();
            reader.readAsDataURL(res.data);
            reader.onloadend = () => {
              const base64Data = reader.result;
              this.file.signature = base64Data;
              localStorage.setItem("signature", base64Data);
            };
          }
        })
        .catch(async (err) => {
          let text;
          let errorData = await axios.get(
            URL.createObjectURL(err.response.data)
          );
          if (errorData.data.message == "file not found") {
            text = "Tanda tangan belum dibuat";
          }
          ToastFailed.fire({
            icon: "error",
            title: text,
          });
        })
        .finally(() => useUIStore().setLoading(false));
    },
    async getInitial(forced = false) {
      const { isUser } = await useMiddleware();
      if ((this.file.initial && !forced) || !isUser.value) return;
      useUIStore().setLoading(true);
      http({ path: "auth" })
        .get(`user-initial/${this.user.id}`, {
          responseType: "blob",
          validateStatus: function (status) {
            return status < 501;
          },
        })
        .then(async (res) => {
          if (res.status != 404) {
            const reader = new FileReader();
            reader.readAsDataURL(res.data);
            reader.onloadend = () => {
              const base64Data = reader.result;
              this.file.initial = base64Data;
              localStorage.setItem("initial", base64Data);
            };
          }
        })
        .catch(async (err) => {
          let text;
          let errorData = await axios.get(
            URL.createObjectURL(err.response.data)
          );
          if (errorData.data.message == "file not found") {
            text = "Paraf belum dibuat";
          }
          ToastFailed.fire({
            icon: "error",
            title: text,
          });
        })
        .finally(() => useUIStore().setLoading(false));
    },
    async getBSRESignature(forced = false) {
      if (
        this.file.bsreSignature.short &&
        this.file.bsreSignature.long &&
        this.file.bsreSignature.wrapLong &&
        this.file.bsreSignature.wrapShort &&
        !forced
      ) {
        return;
      }
      useUIStore().setLoading(true);

      const fetchSignature = async (params, storageKey) => {
        try {
          const res = await http({ path: "signer" }).get("signature", {
            params,
            responseType: "blob",
            validateStatus: (status) => status < 501,
          });
          if (res.status === 404 || res.status === 500) return null;
          return await new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => {
              const base64Data = reader.result;
              this.file.bsreSignature[storageKey] = base64Data;
              localStorage.setItem(
                `bsreSignature${storageKey.charAt(0).toUpperCase() + storageKey.slice(1)}`,
                base64Data
              );
              resolve(base64Data);
            };
            reader.readAsDataURL(res.data);
          });
        } catch (err) {
          ToastFailed.fire({
            icon: "error",
            title: err.message,
          });
          return null;
        }
      };

      await Promise.all([
        fetchSignature(
          { pangkatLengkap: true, namaPenyesuaian: false },
          "long"
        ),
        fetchSignature(
          { pangkatLengkap: false, namaPenyesuaian: false },
          "short"
        ),
        fetchSignature(
          { pangkatLengkap: true, namaPenyesuaian: true },
          "wrapLong"
        ),
        fetchSignature(
          { pangkatLengkap: false, namaPenyesuaian: true },
          "wrapShort"
        ),
      ]);

      useUIStore().setLoading(false);
    },
    getSummaryFiles() {
      if (!this.isDataExpired("getSummaryFiles")) {
        return;
      }
      useUIStore().setLoading(true);
      http({ path: "docs" })
        .get("dashboard/summary", { params: { user_id: this.user.id } })
        .then((res) => {
          this.summary = res.data.data;
          this.lastFetchTime["getSummaryFiles"] = new Date();
        })
        .catch((err) =>
          ToastFailed.fire({
            icon: "error",
            title: err.message,
          })
        )
        .finally(() => useUIStore().setLoading(false));
    },
    getUserInfo() {
      if (!this.isDataExpired("getUserInfo")) {
        return;
      }
      useUIStore().setLoading(true);

      let path = "information/total-users-tte";
      // let params = { params: { user_id: this.user.id } };

      http({ path: "auth" })
        .get(path)
        .then((res) => {
          this.allUsersInfo = res.data.data.totalUsers;
          this.lastFetchTime["getUserInfo"] = new Date();
        })
        .catch((err) =>
          ToastFailed.fire({
            icon: "error",
            title: err.message,
          })
        );
      // .finally(() => useUIStore().setLoading(false));
    },
    getUserBSREInfo() {
      if (!this.isDataExpired("getUserBSREInfo")) {
        return;
      }
      useUIStore().setLoading(true);

      let path = "/users/list-response-bsre";
      let params = { params: { user_id: this.user.id } };

      http({ path: "auth" })
        .get(path, params)
        .then((res) => {
          this.userBSREInfo = res.data.data;

          this.lastFetchTime["getUserBSREInfo"] = new Date();
        })
        .catch((err) =>
          ToastFailed.fire({
            icon: "error",
            title: err.message,
          })
        );
      // .finally(() => useUIStore().setLoading(false));
    },
    getFilesInfo() {
      if (!this.isDataExpired("getFilesInfo")) {
        return;
      }
      useUIStore().setLoading(true);

      let path = "dashboard/file-capacity";
      let params = { params: { user_id: this.user.id } };

      http({ path: "docs" })
        .get(path, params)
        .then((res) => {
          this.filesInfo = res.data.data;
          this.lastFetchTime["getFilesInfo"] = new Date();
        })
        .catch((err) =>
          ToastFailed.fire({
            icon: "error",
            title: err.message,
          })
        )
        .finally(() => useUIStore().setLoading(false));
    },
    getAllFilesInfo() {
      if (!this.isDataExpired("getAllFilesInfo")) {
        return;
      }
      useUIStore().setLoading(true);

      http({ path: "docs" })
        .get("information/total-files")
        .then((res) => {
          this.allFilesInfo = res.data.data.totalFiles;
          this.lastFetchTime["getAllFilesInfo"] = new Date();
        })
        .catch((err) =>
          ToastFailed.fire({
            icon: "error",
            title: err.message,
          })
        )
        .finally(() => useUIStore().setLoading(false));
    },
    getStorageInfo() {
      if (!this.isDataExpired("getStorageInfo")) {
        return;
      }
      useUIStore().setLoading(true);
      http({ path: "docs" })
        .get("dashboard/storage-capacity", {
          params: { user_id: this.user.id },
        })
        .then((res) => {
          this.storageInfo = res.data.data;
          this.lastFetchTime["getStorageInfo"] = new Date();
        })
        .catch((err) =>
          ToastFailed.fire({
            icon: "error",
            title: err.message,
          })
        )
        .finally(() => useUIStore().setLoading(false));
    },
    getDataDashboard() {
      useDocumentStore().loadDataSubmission();
      this.getFilesInfo();
      this.getStorageInfo();
      this.getSummaryFiles();
      this.getInitial();
      this.getSignature();
      this.getBSRESignature();

      const { isSuperAdmin, isAdmin } = useMiddleware();
      if (isSuperAdmin.value || isAdmin.value) {
        this.getAllFilesInfo();
        this.getUserBSREInfo();
      }
    },
    updateParaf({ type = "signature", file }) {
      useUIStore().setLoading(true);
      let data = new FormData(),
        url = "user-signature";

      data.append("file", file);
      data.append("user_id", this.user.id);

      if (type == "paraf") url = "user-initial";

      http({ path: "auth" })
        .post(url, data)
        .then((res) => {
          if (type == "signature") {
            this.getSignature(true);
            this.file.signatureFileName = res.data.data.file;
            this.user.signature = res.data.data.file;
            localStorage.setItem("user", JSON.stringify(this.user));
          } else if (type == "paraf") {
            this.getInitial(true);
            this.file.initialFileName = res.data.data.file;
            this.user.initial = res.data.data.file;
            localStorage.setItem("user", JSON.stringify(this.user));
          }
        })
        .catch((err) =>
          ToastFailed.fire({
            icon: "error",
            title: err.message,
          })
        )
        .finally(() => useUIStore().setLoading(false));
    },
    async updatePhoneNumber(phone) {
      useUIStore().setLoading(true);
      return http({ path: "auth" })
        .put(`users/${this.user.id}`, {
          phone,
        })
        .then((res) => {
          this.user.phone = res.data.data.phone;
          this.user.whatsapp_number = res.data.data.whatsapp_number;
          localStorage.setItem("user", JSON.stringify(this.user));
          ToastSuccess.fire({
            icon: "success",
            title: "Data berhasil diperbaharui",
          });
          return { isConfirmed: true };
        })
        .catch((err) =>
          ToastFailed.fire({
            icon: "error",
            title: err.response.data.errors.phone[0],
          })
        )
        .finally(() => useUIStore().setLoading(false));
    },
    async changeUserRole(user_id, role_id) {
      useUIStore().setLoading(true);

      try {
        await Promise.all(
          // this.getRoles({ limit: 5, offset: 0, orderBy: "name", direction: "asc", name: "Admin" }),
          http({ path: "auth" })
            .post(`users/add-role`, {
              user_id: user_id,
              role_id: role_id,
            })
            .then(() => {
              ToastSuccess.fire({
                icon: "success",
                title: "Role berhasil ditambahkan",
              });
            })
            .catch((err) => {
              throw err;
            })
        );
      } catch (err) {
        ToastFailed.fire({
          icon: "error",
          title: err.message,
        });
      } finally {
        useUIStore().setLoading(false);
      }
    },
    async getRoles(params) {
      useUIStore().setLoading(true);
      try {
        await http({ path: "auth" })
          .get("roles", { params })
          .then((res) => {
            this.roles = res.data.data;
          })
          .catch((err) => {
            throw err;
          })
          .finally(() => {
            useUIStore().setLoading(false);
          });
      } catch (err) {
        ToastFailed.fire({
          icon: "error",
          title: err.message,
        });
      }
    },
    async changeNIK(nik) {
      useUIStore().setLoading(true);
      return http({ path: "auth" })
        .put(`users/${this.user.id}`, {
          nik,
        })
        .then((res) => {
          this.user.nik = res.data.data.nik;
          localStorage.setItem(
            "user",
            JSON.stringify({
              ...JSON.parse(localStorage.getItem("user")),
              nik: res.data.data.nik,
            })
          );
          ToastSuccess.fire({
            icon: "success",
            title: "NIK berhasil diperbaharui",
          });
          return true;
        })
        .catch((err) => {
          ToastFailed.fire({
            icon: "error",
            title: err.response.data.message,
          });
          return false;
        })
        .finally(() => useUIStore().setLoading(false));
    },
    async changeNamaPendek(namaPendek) {
      useUIStore().setLoading(true);
      return http({ path: "auth" })
        .put(`users/${this.user.id}`, {
          nama_pendek_dengan_gelar: namaPendek,
        })
        .then((res) => {
          this.user.nama_pendek_dengan_gelar =
            res.data.data.nama_pendek_dengan_gelar;
          localStorage.setItem(
            "user",
            JSON.stringify({
              ...JSON.parse(localStorage.getItem("user")),
              nama_pendek_dengan_gelar: res.data.data.nama_pendek_dengan_gelar,
            })
          );
          ToastSuccess.fire({
            icon: "success",
            title: "Nama penyesuaian berhasil diperbaharui",
          });
          return true;
        })
        .catch((err) => {
          ToastFailed.fire({
            icon: "error",
            title: err.response.data.message,
          });
          return false;
        })
        .finally(() => useUIStore().setLoading(false));
    },

    async synchronize(nrp = null) {
      useUIStore().setLoading(true);
      try {
        // Determine which NRP to use: provided nrp (other user) or current user's nrp
        const targetNrp = nrp
          ? nrp
          : this.user.nrp || this.user.email?.split("@")[0] || "";

        if (!targetNrp) {
          ToastFailed.fire({
            icon: "error",
            title: "NRP Tidak valid, Harap hubungi admin untuk validasi!",
          });
          return;
        }

        const res = await http({ path: "auth" }).get("sipp", {
          params: { nrp: targetNrp },
        });
        const data = res.data.data || res.data;

        if (!data.nrp) {
          ToastFailed.fire({
            icon: "error",
            title: "NRP Tidak valid, Harap hubungi admin untuk validasi!",
          });
          return;
        }

        // Only update current user's data if syncing own account (nrp is null)
        if (!nrp) {
          Object.assign(this.user, {
            email: data.email,
            name: data.nama_dengan_gelar || data.nama, //Merubah nama dengan Gelar jika ada, jika tidak ada maka menggunakan nama tanpa gelar
            nama_tanpa_gelar: data.nama?.includes(",")
              ? data.nama.split(",").shift().trim()
              : data.nama,
            pangkat: data.pangkat,
            pangkat_lengkap: data.pangkat_lengkap,
            jabatan: data.jabatan,
            satuan: data.satuan1,
            satuan1: data.satuan1,
            satuan2: data.satuan2,
            satuan3: data.satuan3,
            nik: data.nik,
            handphone: data.handphone,
            tanggal_lahir: data.tanggal_lahir,
          });
          localStorage.setItem("user", JSON.stringify(this.user));

          ToastSuccess.fire({
            icon: "success",
            title: "Akun berhasil di sinkronisasi",
          });
        }

        return data;
      } catch (err) {
        ToastFailed.fire({
          icon: "error",
          title:
            err?.response?.data?.message ||
            err.message ||
            "Terjadi kesalahan saat sinkronisasi",
        });
      } finally {
        useUIStore().setLoading(false);
      }
    },
    async suspendAccount(id) {
      useUIStore().setLoading(true);
      http({ path: "auth" })
        .post("users/account-suspend", { user_id: id })
        .then((res) => {
          if (res.status == 200) {
            ToastSuccess.fire({
              icon: "success",
              title: "Akun berhasil disuspend",
            });
          }
        })
        .finally(() => useUIStore().setLoading(false));
    },
  },
});